import { inject, Injectable } from "@angular/core";
import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { PublicApiService } from "../services/public-api.service";
import { map, of, switchMap, timer } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SenderIdValidator {
  private publicApiService = inject(PublicApiService);

  public get(): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return of(null);

      return timer(500).pipe(
        switchMap(() => {
          return this.publicApiService.validateSenderId$({ name: value }).pipe(
            map(({ isValid, errors }) => isValid ? null : { senderIdValid: errors[0] }),
          );
        }),
      );
    };
  }
}
